export default __webpack_public_path__ + "static/media/mindmap_03.df2e1345.png";